import {CorridorLevelBlock} from './corridor-level-block';
import {EnumCorridorColor} from '../enum/enum-corridor-color';

export class CorridorBlock {
    public corridors: CorridorLevelBlock[];
    public appliedPrice: string;
    public discount: string;
    public appliedColor: EnumCorridorColor;
    public distance: string;


    constructor(corridors: CorridorLevelBlock[], appliedPrice: string, discount: string, appliedColor: EnumCorridorColor, distance: string) {
        this.corridors = corridors;
        this.appliedPrice = appliedPrice;
        this.discount = discount;
        this.appliedColor = appliedColor;
        this.distance = distance;
    }
}
